export const getOrdersData = ({ state }) => state.quickPrinting.ordersData;
export const getCurrentPage = ({ state }) => state.quickPrinting.currentPage;
export const getPageSize = ({ state }) => state.quickPrinting.pageSize;
export const getRowCount = ({ state }) => state.quickPrinting.rowCount;
export const getSelectedOrdersId = ({ state }) => state.quickPrinting.selectedOrderIds;
export const getQueryParams = ({ state }) => state.quickPrinting.queryParams;
